<template lang="html">
	<el-table :data="list" ref="myTable" size="medium" height="100%" row-key="id" border default-expand-all @selection-change="(e)=>{$emit('change_selection',e)}" @sort-change="(e)=>{$emit('sort_change',e)} ">
		<el-table-column type="selection" align="center" width="50" v-if="hasBtn('sys:'+model+':dall')" fixed="left"></el-table-column>
		<!-- <el-table-column align="center" type="index" label="序号" width="50" fixed="left"></el-table-column> -->
		<slot name="left"></slot>
		<el-table-column v-for="(item,index) in header"
			v-if="(item.prop=='status'&&hasBtn('sys:'+model+':status'))||item.prop!='status'"
			:align="item.align?item.align:'center'"
			:key="(index+1)"
			:label="item.label"
			:prop="item.prop"
			:width="item.width?item.width:undefined"
			:min-width="item.minWidth?item.minWidth:undefined"
			:sortable="item.sortable"
			>
			<template slot-scope="{row}">
				<el-switch v-if="item.prop=='status'" v-model="row.status" :inactive-value="2" :active-value="1" @change="$emit('switch_change',row)"></el-switch>
				<el-image v-else-if="item.type=='img'" style="width: 70px; height: 70px" :src="row[item.prop]" fit="contain"></el-image>
				<span v-else-if="item.type=='select'">{{item.select[row[item.prop]]}}</span>
				<span v-else>{{row[item.prop]}}</span>
			</template>
		</el-table-column>
		<slot></slot>
		<el-table-column label="操作" align="center" width="150" fixed="right" key="9999" v-if="operation">
			<template slot-scope="{row}">
				<el-link type="primary" icon="el-icon-edit" v-if="hasBtn('sys:'+model+':edit')" @click="$emit('click_add',row)">修改</el-link>
				<el-popconfirm @confirm="$emit('click_del',row)" title="确定要删除吗？" v-if="hasBtn('sys:'+model+':delete')">
					<el-link type="danger" icon="el-icon-delete" slot="reference">删除</el-link>
				</el-popconfirm>
			</template>
		</el-table-column>
	</el-table>
</template>
<script>
export default {
	name: 'table_table',
	data() {
		return {
		}
	},
	props: {
	    model: {
			type: String,
			default: ''
	    },
	    operation: {
			type: Boolean,
			default: true,
	    },
	    list: {
			type: Array,
			default:()=>[]
	    },
	    header: {
			type: Array,
			default:()=>[]
	    }
	},
	watch:{
		'$route':{
			immediate: true,
			deep: true,
		    handler:function(v){
			    if (this.$refs.myTable && this.$refs.myTable.doLayout) {
			      this.$refs.myTable.doLayout();
			    }
		    }
		}
	},
	updated() {
	    if (this.$refs.myTable && this.$refs.myTable.doLayout) {
	      this.$refs.myTable.doLayout();
	    }
	},
	methods: {
		click_toggle_all(data, isExpansion){
			if(this.$refs.myTable){
				data.forEach((item) => {
					this.$refs.myTable.toggleRowExpansion(item, isExpansion);
					if (item.children !== undefined && item.children !== null) {
						this.click_toggle_all(item.children, isExpansion);
					}
				});
			}
		}
	}
}
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/table_table.vue